import dayjs from "dayjs";

import { PortfolioPerformanceGraphNode } from "@ctypes";

export const nodes: Array<PortfolioPerformanceGraphNode> = (() => {
  const result = [
    { value: 28, timestamp: dayjs().format() },
    { value: 30, timestamp: dayjs().format() },
    { value: 32, timestamp: dayjs().format() },
    { value: 28, timestamp: dayjs().format() },
    { value: 27, timestamp: dayjs().format() },
    { value: 32, timestamp: dayjs().format() },
    { value: 31, timestamp: dayjs().format() },
    { value: 35, timestamp: dayjs().format() },
    { value: 37, timestamp: dayjs().format() },
    { value: 40, timestamp: dayjs().format() },
    { value: 38, timestamp: dayjs().format() },
    { value: 40, timestamp: dayjs().format() },
    { value: 40, timestamp: dayjs().format() },
    { value: 42, timestamp: dayjs().format() },
    { value: 43, timestamp: dayjs().format() },
    { value: 38, timestamp: dayjs().format() },
    { value: 37, timestamp: dayjs().format() },
    { value: 36, timestamp: dayjs().format() },
    { value: 39, timestamp: dayjs().format() },
    { value: 43, timestamp: dayjs().format() },
    { value: 42, timestamp: dayjs().format() },
    { value: 44, timestamp: dayjs().format() },
    { value: 45, timestamp: dayjs().format() },
    { value: 43, timestamp: dayjs().format() },
    { value: 40, timestamp: dayjs().format() },
    { value: 43, timestamp: dayjs().format() },
    { value: 40, timestamp: dayjs().format() },
    { value: 38, timestamp: dayjs().format() },
    { value: 41, timestamp: dayjs().format() },
    { value: 45, timestamp: dayjs().format() },
    { value: 49, timestamp: dayjs().format() },
    { value: 53, timestamp: dayjs().format() },
    { value: 52, timestamp: dayjs().format() },
    { value: 55, timestamp: dayjs().format() },
    { value: 60, timestamp: dayjs().format() },
    { value: 58, timestamp: dayjs().format() },
    { value: 60, timestamp: dayjs().format() },
    { value: 58, timestamp: dayjs().format() },
    { value: 60, timestamp: dayjs().format() },
    { value: 57, timestamp: dayjs().format() },
    { value: 53, timestamp: dayjs().format() },
    { value: 55, timestamp: dayjs().format() },
    { value: 53, timestamp: dayjs().format() },
    { value: 50, timestamp: dayjs().format() },
    { value: 51, timestamp: dayjs().format() },
    { value: 50, timestamp: dayjs().format() },
    { value: 47, timestamp: dayjs().format() },
    { value: 45, timestamp: dayjs().format() },
    { value: 47, timestamp: dayjs().format() },
    { value: 48, timestamp: dayjs().format() },
    { value: 46, timestamp: dayjs().format() },
    { value: 45, timestamp: dayjs().format() },
  ];

  return result;
})();
